<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Edit Profile</h4>
    </div>
    <div class="card-body">
      <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(updateProfile)">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Company"
                      :disabled="true"
                      placeholder="Mundial Media"
                      v-model="user.init_irisprofile">
            </fg-input>
          </div>



          <!-- OG field
          <div class="col-md-3">
            <ValidationProvider
              name="username"
              rules="min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input type="text"
                      :error="failed ? 'Username must be at least 2 characters': null"
                      :hasSuccess="passed"
                      name="username"
                      label="Username"
                      placeholder="Username"
                      v-model="user.new_username">
              </fg-input>
            </ValidationProvider>
          </div>
          -->



          <div class="col-md-6">


            <!-- REMOVED email not needed
            END -->

            <ValidationProvider
              name="email"
              rules="email|min:5"
              v-slot="{ passed, failed }"
            >
              <fg-input type="email"
                      :error="failed ? 'Email must be at least 5 characters': null"
                      :hasSuccess="passed"
                      name="email"
                      label="Email"
                      :disabled="true"
                      placeholder="Email"
                      v-model="user.new_email">
              </fg-input>
            </ValidationProvider>


          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="firstname"
              rules="min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input type="text"
                      :error="failed ? 'Password must be at least 2 characters': null"
                      :hasSuccess="passed"
                      name="firstname"
                      label="First Name"
                      placeholder="First Name"
                      v-model="user.new_first_name">
              </fg-input>
            </ValidationProvider>
          </div>
            <div class="col-md-6">
            <ValidationProvider
              name="lastname"
              rules="min:1"
              v-slot="{ passed, failed }"
            >
              <fg-input type="text"
                      :error="failed ? 'Last Name must be at least 1 character': null"
                      :hasSuccess="passed"
                      name="lastname"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="user.new_last_name">
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="password"
              rules="required|min:5"
              v-slot="{ passed, failed }"
            >
              <fg-input type="password"
                      :error="failed ? 'The Password field is required': null"
                      :hasSuccess="passed"
                      name="password"
                      label="Current Password (required)"
                      placeholder="Current Password..."
                      v-model="user.init_password">
              </fg-input>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              name="newpassword"
              rules="min:5"
              v-slot="{ passed, failed }"
            >
              <fg-input type="password"
                      :error="failed ? 'New Password must be at least 5 characters': null"
                      :hasSuccess="passed"
                      name="newpassword"
                      label="New Password (optional)"
                      placeholder="New Password..."
                      v-model="user.new_password">
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <hr/>
        <label class="form-field-label">Automated Reporting</label>
        
        <div class="row">
          <div class="col-md-12">
            <ValidationProvider
              name="active"
              rules="required|min:1"
              v-slot="{ passed, failed }"
            >
              <fg-input
                autocomplete="off"
                :error="failed ? 'Active field is required': null"
                :hasSuccess="passed"
                name="active"
                label="Is Active"
                v-model="user.new_autoreport"
              >


                <div class="clearfix"></div>
                <el-select class="select-default iris-default"
                           size="large"
                           v-model="user.new_autoreport"
                           placeholder="Required *">
                      <el-option v-for="option in [{'label':'Inactive','value':0},{'label':'Active','value':1}]"
                               class="select-default"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                      </el-option>
                </el-select>


              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row" v-if="isAutoReport">
          <div class="col-md-3">
            <fg-input
                autocomplete="off"
                :error="failed ? 'Date is required': null"
                :hasSuccess="passed"
                name="daterange"
                label="Date Range"
                v-model="user.new_filters.date"
              >
                <el-select class="select-default iris-default"
                           size="large"
                           v-model="user.new_filters.date"
                           placeholder="Required *">
                      <el-option v-for="option in [
                                 {'label':'Yesterday','value':'yesterday'},
                                 {'label':'Last 7 Days','value':'lastSeven'},
                                 {'label':'Last 30 Days','value':'lastThirty'},
                               ]"
                               class="select-default"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                      </el-option>
                </el-select>
              </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
                autocomplete="off"
                :error="failed ? 'Time is required': null"
                :hasSuccess="passed"
                name="daterange"
                label="Time (Pacific Time)"
                v-model="user.new_filters.time"
              >
                <el-select class="select-default iris-default"
                           size="large"
                           v-model="user.new_filters.time"
                           placeholder="Required *">
                      <el-option v-for="option in [
                                 {'label':'MIDNIGHT','value':0},
                                 {'label':'1AM','value':1},
                                 {'label':'2AM','value':2},
                                 {'label':'3AM','value':3},
                                 {'label':'4AM','value':4},
                                 {'label':'5AM','value':5},
                                 {'label':'6AM','value':6},
                                 {'label':'7AM','value':7},
                                 {'label':'8AM','value':8},
                                 {'label':'9AM','value':9},
                                 {'label':'10AM','value':10},
                                 {'label':'11AM','value':11},
                                 {'label':'NOON','value':12},
                                 {'label':'1PM','value':13},
                                 {'label':'2PM','value':14},
                                 {'label':'3PM','value':15},
                                 {'label':'4PM','value':16},
                                 {'label':'5PM','value':17},
                                 {'label':'6PM','value':18},
                                 {'label':'7PM','value':19},
                                 {'label':'8PM','value':20},
                                 {'label':'9PM','value':21},
                                 {'label':'10PM','value':22},
                                 {'label':'11PM','value':23},
                               ]"
                               class="select-default"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                      </el-option>
                </el-select>
              </fg-input>
          </div>
          <div class="col-md-3">
            <div v-if="store.irisData && store.irisData.user.is_staff" class="form-group">
              <fg-input label="Billing Entity" v-if="store.irisData">
                <el-select class="select-default iris-default"
                       size="large"
                       v-model="user.new_filters.billing_entity"
                       placeholder="All">
                  <el-option v-for="option in [{value:'all', label:'All'}].concat(store.irisData.be_options)"
                           class="select-default"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
          </div>
          <div class="col-md-3">              
          </div>
        </div>

        <div class="row" v-if="isAutoReport">
          <div class="col-md-3">
            <fg-input label="Site" v-if="store.irisData">
              <el-select multiple class="select-default iris-default"
                       size="large"
                       v-model="user.new_filters.site_name"
                       placeholder="All">
                  <el-option v-for="option in [{value:'all',label:'All'}].concat(siteOptions)"
                           class="select-default"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                  </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input label="Device" v-if="store.irisData">
              <el-select class="select-default iris-default"
                       size="large"
                       v-model="user.new_filters.device_type"
                       placeholder="All">
                  <el-option v-for="option in [{value:'all',label:'All'}].concat(store.irisData.device_options)"
                           class="select-default"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                  </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input label="Product" v-if="store.irisData">
              <el-select multiple class="select-default iris-default"
                       size="large"
                       v-model="user.new_filters.product_type"
                       placeholder="All">
                  <el-option v-for="option in [{value:'all',label:'All'}].concat(store.irisData.product_options)"
                           class="select-default"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                  </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input label="Sub-Product" v-if="store.irisData">
              <el-select multiple class="select-default iris-default"
                       size="large"
                       v-model="user.new_filters.product_subtype"
                       placeholder="All">
                  <el-option v-for="option in [{value:'all',label:'All'}].concat(subProductOptions)"
                           class="select-default"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                  </el-option>
              </el-select>
            </fg-input>
          </div>
        </div>

        <div class="text-center">
          <button type="submit" class="btn btn-info btn-fill btn-wd">
            Update Profile
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
  import { store } from 'src/store'
  import { extend } from "vee-validate";
  import { required, email, min } from "vee-validate/dist/rules";

  extend("required", required);
  extend("email", email);
  extend("min", min);

  // Global templates
  const userObj = {
          init_id: '',
          init_irisprofile: '',
          init_username: '',
          init_email: '',
          init_first_name: '',
          init_last_name: '',
          init_password: '',
          init_autoreport: '',
          init_filters: {
            date: 'lastSeven',
            time: 10,
            billing_entity: 'all',
            site_name: ['all'],
            device_type: 'all',
            product_type: ['all'],
            product_subtype: ['all'],
    },

          new_username: '',
          new_email: '',
          new_first_name: '',
          new_last_name: '',
          new_password: '',
          new_autoreport: '',
          new_filters: {
            date: 'lastSeven',
            time: 10,
            billing_entity: 'all',
            site_name: ['all'],
            device_type: 'all',
            product_type: ['all'],
            product_subtype: ['all'],
    },
  }

  export default {
    data () {
      return {
        store,
        userOG: {},
        user: JSON.parse(JSON.stringify(userObj)),
        //user: {
          //init_id: '',
          //init_irisprofile: '',
          //init_username: '',
          //init_email: '',
          //init_first_name: '',
          //init_last_name: '',
          //init_password: '',
          //init_autoreport: '',
          //init_filters: {
            //date: 'lastSeven',
            //time: 10,
            //billing_entity: 'all',
            //site_name: ['all'],
            //device_type: 'all',
            //product_type: ['all'],
            //product_subtype: ['all'],
          //},

          //new_username: '',
          //new_email: '',
          //new_first_name: '',
          //new_last_name: '',
          //new_password: '',
          //new_autoreport: '',
          //new_filters: {
            //date: 'lastSeven',
            //time: 10,
            //billing_entity: 'all',
            //site_name: ['all'],
            //device_type: 'all',
            //product_type: ['all'],
            //product_subtype: ['all'],
          //},
        //}
      }
    },
    methods: {
      resetProfile () {
          const userOG = this.userOG;

          if (userOG.new_autoreport) userOG.new_autoreport = Number(!(!!userOG.new_autoreport))

          this.user = JSON.parse(JSON.stringify(userOG));
      },
      setProfile () {
          const user = this.user;
          user.init_id = store.irisData.user.id
          user.init_irisprofile = store.irisData.user.irisprofile
          user.init_username = store.irisData.user.username
          user.init_email = store.irisData.user.email
          user.init_first_name = store.irisData.user.first_name
          user.init_last_name = store.irisData.user.last_name
          user.init_autoreport = store.irisData.user.autoreport
          user.init_filters = { ...this.user.init_filters, ...store.irisData.user.filters };

          user.new_username = store.irisData.user.username
          user.new_email = store.irisData.user.email
          user.new_first_name = store.irisData.user.first_name
          user.new_last_name = store.irisData.user.last_name
          user.new_autoreport = store.irisData.user.autoreport
          user.new_filters = { ...this.user.init_filters, ...store.irisData.user.filters };

          //
          // CREATE OG
          //
          this.userOG = JSON.parse(JSON.stringify(user));
      },
      async updateProfile () {
        const userUpdates = {},
        user = this.user;
        let updateFlag = false
        userUpdates.og_username = user.init_username
        userUpdates.og_password = user.init_password

        //if (this.user.new_username.length && this.user.init_username !== this.user.new_username) {
        //    userUpdates.username = this.user.new_username
        //    updateFlag = true
        //}
 
        //if (this.user.new_email.length && this.user.init_email !== this.user.new_email) {
        //    userUpdates.email = this.user.new_email
        //    userUpdates.username = this.user.new_email
        //    updateFlag = true
        //}

        if (user.new_first_name.length && user.init_first_name !== user.new_first_name) {
            userUpdates.first_name = user.new_first_name
            updateFlag = true
        }

        if (user.new_last_name.length && user.init_last_name !== user.new_last_name) {
            userUpdates.last_name = user.new_last_name
            updateFlag = true
        }

        if (user.new_password.length && user.init_password !== user.new_password) {
            userUpdates.password = user.new_password
            updateFlag = true
        }

        if (Object.keys(user.new_filters).length && JSON.stringify(user.new_filters) !== JSON.stringify(user.init_filters)) {
            userUpdates.filters = user.new_filters
            updateFlag = true
        }

        //
        // INT type does not have 'length' property inherently -> int.length = undefined
        //
        //let resetFiltersFlag = false
        if (user.new_autoreport.toString().length && user.init_autoreport !== user.new_autoreport) {
            userUpdates.autoreport = user.new_autoreport
            updateFlag = true

            //if (!(!!userUpdates.autoreport)) resetFiltersFlag = true 
        }

        //console.log('Your data: ' + JSON.stringify(user))
        //console.log({updateFlag})

        if (updateFlag) {
            
            //console.log('Your updates: ' + JSON.stringify(userUpdates))
            //console.log('Update! ',{ updateFlag })
            //console.log('Reset! ',{ resetFiltersFlag })

            const boolCheck = await store.updateIris(userUpdates)
            if (boolCheck === 'EXISTING_USERNAME') {
                alert('EMAIL already exists!')
            } else if (boolCheck) {
                // RESET if now inactive
                //if (resetFiltersFlag) this.user = JSON.parse(JSON.stringify(userObj));

                // ALERT - confirm success then setProfile
                alert('Profile updated successfully!')
                this.setProfile()
            } else {
                alert('EMAIL or PASSWORD is incorrect!')
            }
        } else {
          alert('No changes identified!')
        }
      }
    },
    mounted () {
      this.setProfile()

      if (store.irisData.sessionFilters) store.irisData.sessionFilters = false

      //console.log({store})
    },
    watch: {
      isAutoReport (val) {
        if (!val) {
          this.resetProfile()
        }
      }
    },
    computed: {
      isAutoReport () {
        return this.user.new_autoreport
      },
      siteOptions () {
        const user = this.user,
        companySelected = user.new_filters.billing_entity === 'all' ? false : store.irisData.be_options.filter(obj => obj.value === user.new_filters.billing_entity)[0],
        be_id = companySelected ? companySelected.value : false,
        be_sn_set = be_id ? new Set(store.irisData.be_sn_dict.filter(obj => obj.be_id === be_id)[0].sn_id.split(',')) : false;

        //console.log({companySelected, be_id, be_sn_set})

        return be_sn_set ? store.irisData.site_options.filter(obj => be_sn_set.has(obj.value.toString())) : store.irisData.site_options
      },
      subProductOptions () {
        const user = this.user,
        productSet = new Set(user.new_filters.product_type), allFlag = productSet.has('all'),
        productSelected = allFlag ? false : store.irisData.product_options.filter(obj => productSet.has(obj.value)),
        productIdSet = productSelected ? new Set(productSelected.map(prod => prod.value)) : false,
        subproduct_list = productIdSet ? store.irisData.product_subproduct_dict.filter(obj => productIdSet.has(obj.product_type_id)) : [],
        product_subproduct_set = productIdSet && subproduct_list.length ? new Set(subproduct_list.flatMap(obj => obj.product_subtype_id.split(','))) : false;

        //console.log({productSet,allFlag,productSelected,productIdSet,subproduct_list})

        return product_subproduct_set ? store.irisData.subproduct_options.filter(obj => product_subproduct_set.has(obj.value.toString())) :
          productIdSet && !subproduct_list.length ? [] : store.irisData.subproduct_options
      },
    },
  }

</script>
<style>
.form-group.has-label label {
    font-weight: bolder;
}

.form-field-label {
    font-weight: bolder;
}
</style>
